export const TRANSACTION_STATUS_PENDING = 0;
export const TRANSACTION_STATUS_VALIDATED = 1;
export const TRANSACTION_STATUS_REJECTED = 2;
export const TRANSACTION_STATUS_APPLIED = 3;
export const TRANSACTION_STATUS_DISCARDED = 4;
export const TRANSACTION_STATUS_DRAFT = 5;
